import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'Switch',
  props: {
  actived: {
    type: Boolean,
    required: true,
  },
},
  emits: ["update:actived"],
  setup(__props, { emit }) {

const props = __props;





const handleClick = () => {
  emit("update:actived", !props.actived);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative w-14 h-6 p-0.5 rounded-full cursor-pointer transition-colors", { 'bg-gray-400': !__props.actived, 'bg-green-400': __props.actived }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClick()))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["absolute w-5 h-5 rounded-full bg-white transition-transform", { 'translate-x-0': !__props.actived, 'translate-x-8': __props.actived }])
    }, null, 2)
  ], 2))
}
}

})